// extracted by mini-css-extract-plugin
module.exports = {"scrollbarFix":"ActivityIndicator_scrollbarFix__Gatje","noScroll":"ActivityIndicator_noScroll__LBfIK","overlay":"ActivityIndicator_overlay__rcIo9"};